// extracted by mini-css-extract-plugin
module.exports = {"addSectionButton":"AddButton_addSectionButton__M858f","text":"AddButton_text__3AStb"};